// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/homeFont1.OTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/homeFont2.OTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/buttonFont.OTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/images/concesionaria.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/images/signInBackground.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  overflow: scroll;
  overflow-x: hidden;
  font-size: 12px;
}

@font-face {
  font-family: "homeFont";
  src: local("homeFont"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

@font-face {
  font-family: "homeFontTwo";
  src: local("homeFontTwo"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

@font-face {
  font-family: "buttonFont";
  src: local("buttonFont"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

.fontHome {
  font-family: "homeFont";
}

.imgHome {
  position: relative;
  display: inline-block;
  text-align: center;
  max-width: 80%;
}

.imgHome2 {
  height: auto;
  max-width: 100%;
  position: relative;
  display: inline-block;
  text-align: center;
}

.imgAdv1 {
  height: auto;
  max-width: 100%;
  position: relative;
  display: inline-block;
  text-align: center;
}

.imgLogo {
  width: 60%;
  align-items: center;
}

.imgLogoCarousel {
  position: absolute;
  width: 60%;
  align-items: Laeft;
}

.imgLogoSeccPubli1 {
  width: 20%;
  align-items: center;
}
.iconAM {
  color: #fdfefe;
}

.imgCarHome {
  position: relative;
  display: inline-block;
}

.contenedor-flexbox {
  display: flex; /*Convertimos al menú en flexbox*/
  justify-content: space-between; /*Con esto le indicamos que margine todos los items que se encuentra adentro hacia la derecha e izquierda*/
  align-items: center; /*con esto alineamos de manera vertical*/
}

.textRelation {
  width: 100%;
  height: auto;
}

.textCardConcess {
  font-family: "Gill Sans", "Gill Sans MT", "Trebuchet MS", sans-serif;
  font-weight: bold;
  font-size: 18px;
  color: #fdfefe;
  z-index: 1000;
}

.favIcon {
  position: absolute;
  top: 90%;
  right: 90%;
}

.z-index-100 {
  z-index: 1000;
}

.textHomeTwo {
  position: absolute;
  top: 20%;
  left: 40%;
  transform: translate(-50%, -50%);
}

.textAdvHome {
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.textAdvSec {
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.textConcessionaire {
  position: absolute;
  top: 95%;
  left: 48%;
  transform: translate(-47%, -40%);
}

.textSecHomeTwo {
  position: absolute;
  bottom: 12px;
  z-index: 1;
  margin: 0 auto;
  left: 0;
  right: 0;
  font-size: 14px;
  color: #fff;
}

.textHomeTree {
  position: absolute;
  top: 20%;
  left: 25%;
  transform: translate(-50%, -50%);
}

.textSecHomeTree {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.concessLog {
  position: absolute;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.filters__title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--grey1);
}

.App {
  text-align: center;
}

.borderDetail {
  border: none;
  border-top-left-radius: 70px;
  border-top-right-radius: 70px;
}

.tableDetail {
  height: 100%;
}

.divDetail {
  border: none;
  width: 1080px;
  height: 300px;
  overflow-y: hidden;
}

.divPagination {
  border: none;
  width: 250px;
  height: 50px;
  overflow-x: auto;
  display: flex;
  justify-content: start;
  align-items: center;
  margin: auto;
}

.divRelatedConcess {
  border: 3px;
  width: 800px;
  height: 300px;
  overflow-x: auto;
  display: flex;
  justify-content: start;
  align-items: center;
  margin: 1px;
}

.contenedor-icono-enlace {
  display: flex;
  align-items: center;
}

.card-custom {
  width: 100%;
  height: 100%;
}

.divSetPrice {
  border: "1px solid rgba(0, 0, 0, 0.05)";
  width: 200px;
  height: 100px;
  padding: 1em;
}

.divRelation {
  width: 80%;
  height: auto;
  overflow-y: hidden;
}

.concessHead {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  height: auto;
  max-width: 100%;
}

.imgCarDetail {
  height: inherit;
  width: 100%;
  object-fit: contain;
}
.imgPrincipalCarouselAndAd {
  height: inherit;
  width: 100%;
  object-fit: cover;
}

.divConcessCard {
  border: none;
  width: 200px;
  height: auto;
}

.divDolar {
  max-width: 100%;
  height: auto;
}

.borderCardDetail {
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 50px;
  border-top-right-radius: 30px;
  border: none;
}

.signInImage {
  height: 100vh;
  background: url("https://images.unsplash.com/photo-1608911417433-8b0c9235f9cf?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80");
  background-repeat: round;
}

.signUpImage {
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.083),
      rgba(255, 255, 255, 0.5)
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  min-height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.signUpPageForm {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 5%;
  padding: 1em;
  box-sizing: border-box;
}

.buttonContact {
  width: 40px;
  height: 40px;
}

/* .ConcessionaireImage {
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.083),
      rgba(255, 255, 255, 0.5)
    ),
    url("./assets/images/concessionaireHome.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  max-width: 100%;
  max-height: auto;
} */

.bgImage {
  width: 100%;
  background: url("https://www.revistacodigos.com/wp-content/uploads/2019/12/AUTOS.jpg");
  background-repeat: no-repeat;
}
.m-top-40 {
  top: 40px;
}

table caption {
  max-width: calc(100vw - 1.5rem);
  position: sticky;
  left: 0;
}

.hr-line {
  border-color: darkgrey;
  width: 25%;
}

font-size-08 {
  font-size: 0.8rem;
}

@media (max-width: 768px) {
  .margin-top-50 {
    margin-top: 50%;
  }
}

::-webkit-scrollbar {
  width: 0px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* this class is used to hide the file input */
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.inputfile + label {
  font-size: 1em;
  font-weight: 700;
  color: white;
  background-color: #297cff;
  display: inline-block;
  padding: 5px;
  border-radius: 5px;
}

.inputfile:focus + label,
.inputfile + label:hover {
  background-color: #266296;
}

.inputfile + label {
  cursor: pointer; /* "hand" cursor */
}

.inputfile:focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}

.checkbox {
  width: 20px;
  height: 20px;

  border: 2px solid #000;
}

/* Ocultar arrows en input type number */

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.button-without-style {
  padding: 0;
  border: none;
  background: none;
}

.cardReltacionCar {
  width: 30px;
  flex: 1 1;
  flex-direction: "row";
}

.containerDetail {
  background-color: #eeeeee;
}

.bk__white-smoke {
  background-color: #f5f5f5;
}

.canceled-publication {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  padding: 15px;
  border-radius: 5px;
  text-align: center;
  font-style: italic;
  opacity: 0.6;
}

.paused-publication {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  padding: 15px;
  border-radius: 5px;
  text-align: center;
  font-weight: bold;
  opacity: 0.8;
}

.custom-row td th {
  vertical-align: middle;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kFAA8E;AAChF;;AAEA;EACE,0BAA0B;EAC1B;8DACwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB;8DACyD;AAC3D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa,EAAE,iCAAiC;EAChD,8BAA8B,EAAE,0GAA0G;EAC1I,mBAAmB,EAAE,wCAAwC;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oEAAoE;EACpE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,OAAO;EACP,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yDAA0D;EAC1D,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kLAAkL;EAClL,wBAAwB;AAC1B;;AAEA;EACE;;;;2CAI6C;EAC7C,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,WAAW;EACX,sFAAsF;EACtF,4BAA4B;AAC9B;AACA;EACE,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,UAAU,EAAE,2BAA2B;EACvC,uBAAuB,EAAE,4CAA4C;AACvE;;AAEA,8CAA8C;AAC9C;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,eAAe,EAAE,kBAAkB;AACrC;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,sBAAsB;AACxB;;AAEA,wCAAwC;;AAExC,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["html {\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n  overflow: scroll;\n  overflow-x: hidden;\n  font-size: 12px;\n}\n\n@font-face {\n  font-family: \"homeFont\";\n  src: local(\"homeFont\"), url(\"./assets/fonts/homeFont1.OTF\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"homeFontTwo\";\n  src: local(\"homeFontTwo\"),\n    url(\"./assets/fonts/homeFont2.OTF\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"buttonFont\";\n  src: local(\"buttonFont\"),\n    url(\"./assets/fonts/buttonFont.OTF\") format(\"truetype\");\n}\n\n.fontHome {\n  font-family: \"homeFont\";\n}\n\n.imgHome {\n  position: relative;\n  display: inline-block;\n  text-align: center;\n  max-width: 80%;\n}\n\n.imgHome2 {\n  height: auto;\n  max-width: 100%;\n  position: relative;\n  display: inline-block;\n  text-align: center;\n}\n\n.imgAdv1 {\n  height: auto;\n  max-width: 100%;\n  position: relative;\n  display: inline-block;\n  text-align: center;\n}\n\n.imgLogo {\n  width: 60%;\n  align-items: center;\n}\n\n.imgLogoCarousel {\n  position: absolute;\n  width: 60%;\n  align-items: Laeft;\n}\n\n.imgLogoSeccPubli1 {\n  width: 20%;\n  align-items: center;\n}\n.iconAM {\n  color: #fdfefe;\n}\n\n.imgCarHome {\n  position: relative;\n  display: inline-block;\n}\n\n.contenedor-flexbox {\n  display: flex; /*Convertimos al menú en flexbox*/\n  justify-content: space-between; /*Con esto le indicamos que margine todos los items que se encuentra adentro hacia la derecha e izquierda*/\n  align-items: center; /*con esto alineamos de manera vertical*/\n}\n\n.textRelation {\n  width: 100%;\n  height: auto;\n}\n\n.textCardConcess {\n  font-family: \"Gill Sans\", \"Gill Sans MT\", \"Trebuchet MS\", sans-serif;\n  font-weight: bold;\n  font-size: 18px;\n  color: #fdfefe;\n  z-index: 1000;\n}\n\n.favIcon {\n  position: absolute;\n  top: 90%;\n  right: 90%;\n}\n\n.z-index-100 {\n  z-index: 1000;\n}\n\n.textHomeTwo {\n  position: absolute;\n  top: 20%;\n  left: 40%;\n  transform: translate(-50%, -50%);\n}\n\n.textAdvHome {\n  position: absolute;\n  top: 15%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.textAdvSec {\n  position: absolute;\n  top: 85%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.textConcessionaire {\n  position: absolute;\n  top: 95%;\n  left: 48%;\n  transform: translate(-47%, -40%);\n}\n\n.textSecHomeTwo {\n  position: absolute;\n  bottom: 12px;\n  z-index: 1;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  font-size: 14px;\n  color: #fff;\n}\n\n.textHomeTree {\n  position: absolute;\n  top: 20%;\n  left: 25%;\n  transform: translate(-50%, -50%);\n}\n\n.textSecHomeTree {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.concessLog {\n  position: absolute;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.filters__title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--grey1);\n}\n\n.App {\n  text-align: center;\n}\n\n.borderDetail {\n  border: none;\n  border-top-left-radius: 70px;\n  border-top-right-radius: 70px;\n}\n\n.tableDetail {\n  height: 100%;\n}\n\n.divDetail {\n  border: none;\n  width: 1080px;\n  height: 300px;\n  overflow-y: hidden;\n}\n\n.divPagination {\n  border: none;\n  width: 250px;\n  height: 50px;\n  overflow-x: auto;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  margin: auto;\n}\n\n.divRelatedConcess {\n  border: 3px;\n  width: 800px;\n  height: 300px;\n  overflow-x: auto;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  margin: 1px;\n}\n\n.contenedor-icono-enlace {\n  display: flex;\n  align-items: center;\n}\n\n.card-custom {\n  width: 100%;\n  height: 100%;\n}\n\n.divSetPrice {\n  border: \"1px solid rgba(0, 0, 0, 0.05)\";\n  width: 200px;\n  height: 100px;\n  padding: 1em;\n}\n\n.divRelation {\n  width: 80%;\n  height: auto;\n  overflow-y: hidden;\n}\n\n.concessHead {\n  background-image: url(\"./assets/images/concesionaria.jpg\");\n  height: auto;\n  max-width: 100%;\n}\n\n.imgCarDetail {\n  height: inherit;\n  width: 100%;\n  object-fit: contain;\n}\n.imgPrincipalCarouselAndAd {\n  height: inherit;\n  width: 100%;\n  object-fit: cover;\n}\n\n.divConcessCard {\n  border: none;\n  width: 200px;\n  height: auto;\n}\n\n.divDolar {\n  max-width: 100%;\n  height: auto;\n}\n\n.borderCardDetail {\n  border-bottom-left-radius: 30px;\n  border-bottom-right-radius: 50px;\n  border-top-right-radius: 30px;\n  border: none;\n}\n\n.signInImage {\n  height: 100vh;\n  background: url(\"https://images.unsplash.com/photo-1608911417433-8b0c9235f9cf?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80\");\n  background-repeat: round;\n}\n\n.signUpImage {\n  background-image: linear-gradient(\n      rgba(255, 255, 255, 0.083),\n      rgba(255, 255, 255, 0.5)\n    ),\n    url(\"./assets/images/signInBackground.png\");\n  min-height: 100vh;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.signUpPageForm {\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 5%;\n  padding: 1em;\n  box-sizing: border-box;\n}\n\n.buttonContact {\n  width: 40px;\n  height: 40px;\n}\n\n/* .ConcessionaireImage {\n  background-image: linear-gradient(\n      rgba(255, 255, 255, 0.083),\n      rgba(255, 255, 255, 0.5)\n    ),\n    url(\"./assets/images/concessionaireHome.svg\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n\n  max-width: 100%;\n  max-height: auto;\n} */\n\n.bgImage {\n  width: 100%;\n  background: url(\"https://www.revistacodigos.com/wp-content/uploads/2019/12/AUTOS.jpg\");\n  background-repeat: no-repeat;\n}\n.m-top-40 {\n  top: 40px;\n}\n\ntable caption {\n  max-width: calc(100vw - 1.5rem);\n  position: sticky;\n  left: 0;\n}\n\n.hr-line {\n  border-color: darkgrey;\n  width: 25%;\n}\n\nfont-size-08 {\n  font-size: 0.8rem;\n}\n\n@media (max-width: 768px) {\n  .margin-top-50 {\n    margin-top: 50%;\n  }\n}\n\n::-webkit-scrollbar {\n  width: 0px; /* Remove scrollbar space */\n  background: transparent; /* Optional: just make scrollbar invisible */\n}\n\n/* this class is used to hide the file input */\n.inputfile {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n\n.inputfile + label {\n  font-size: 1em;\n  font-weight: 700;\n  color: white;\n  background-color: #297cff;\n  display: inline-block;\n  padding: 5px;\n  border-radius: 5px;\n}\n\n.inputfile:focus + label,\n.inputfile + label:hover {\n  background-color: #266296;\n}\n\n.inputfile + label {\n  cursor: pointer; /* \"hand\" cursor */\n}\n\n.inputfile:focus + label {\n  outline: 1px dotted #000;\n  outline: -webkit-focus-ring-color auto 5px;\n}\n\n.checkbox {\n  width: 20px;\n  height: 20px;\n\n  border: 2px solid #000;\n}\n\n/* Ocultar arrows en input type number */\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.button-without-style {\n  padding: 0;\n  border: none;\n  background: none;\n}\n\n.cardReltacionCar {\n  width: 30px;\n  flex: 1;\n  flex-direction: \"row\";\n}\n\n.containerDetail {\n  background-color: #eeeeee;\n}\n\n.bk__white-smoke {\n  background-color: #f5f5f5;\n}\n\n.canceled-publication {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  padding: 15px;\n  border-radius: 5px;\n  text-align: center;\n  font-style: italic;\n  opacity: 0.6;\n}\n\n.paused-publication {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeeba;\n  padding: 15px;\n  border-radius: 5px;\n  text-align: center;\n  font-weight: bold;\n  opacity: 0.8;\n}\n\n.custom-row td th {\n  vertical-align: middle;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-left {\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
